var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-2 mt-md-3 mt-xl-4" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", {
          staticClass: "lead fw-bold",
          domProps: { innerHTML: _vm._s(_vm.legalMention.title) },
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "small",
          domProps: { innerHTML: _vm._s(_vm.legalMention.text) },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }